export default "__VITE_ASSET__CfcHXYZy__"